import Vue from 'vue'
import Vuetify from 'vuetify'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import apolloClient from './graphqlclient'
import VueApollo from 'vue-apollo'
import moment from 'moment'

Vue.prototype.moment = moment

import colors from 'vuetify/es5/util/colors'
import './stylus/main.styl'
import i18n from './i18n'

Vue.use(Vuetify, {
  theme: {
    primary: colors.teal,
    secondary: colors.grey.darken1,
    accent: colors.shades.black,
    error: colors.red,
    danger: colors.red.accent3
  }
})

Vue.use(VueApollo)
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})
window.apollo = apolloClient

Vue.config.productionTip = false

window.vm = new Vue({
  router,
  store,
  apolloProvider,
  i18n,
  render: h => h(App)
}).$mount('#app')

if (localStorage.token) store.dispatch('fetchCurrentUser')